"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "withLayout", {
  enumerable: true,
  get: function get() {
    return _withLayout.withLayout;
  }
});
Object.defineProperty(exports, "withSuspense", {
  enumerable: true,
  get: function get() {
    return _withSuspense.withSuspense;
  }
});
var _withLayout = require("./withLayout");
var _withSuspense = require("./withSuspense");